import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import Menu from "@/views/MenuPage.vue";
import FoodPage from "@/views/FoodPage.vue";
import Login from "@/views/LoginPage.vue";
import ProfilePage from "@/views/User/ProfilePage.vue";
// import QRScannerPage from "@/views/QRScannerPage.vue";
import store from "@/store";
import EditProfile from "@/views/User/EditProfile.vue";
import FactorList from "@/views/User/FactorList.vue";
import FactorDetail from "@/views/User/FactorDetail.vue";
import app from "@/main";
import SpecialCategory from "@/views/SpecialCategory.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/menu/:id?",
    name: "Menu",
    component: Menu,
  },
  {
    path: "/specialCategory/:id",
    name: "SpecialCategory",
    component: SpecialCategory,
  },
  {
    path: "/food/:id",
    name: "FoodPage",
    component: FoodPage,
  },
  // {
  //   path: "/qr",
  //   name: "QR",
  //   component: QRScannerPage,
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile/edit",
    name: "EditProfile",
    component: EditProfile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile/factors",
    name: "FactorList",
    component: FactorList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile/factors/:id",
    name: "FactorDetail",
    component: FactorDetail,
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "",
  linkExactActiveClass: "",
  routes,
});

router.beforeEach((to, from, next) => {
  // Close the BottomCart on Route Change (for browser back button)
  app.config.globalProperties.$cart.value = false;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({
        path: "/login",
        query: to.query,
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
